import { useEffect, useRef, useState } from 'react';

export default function usePanelSize(fallbackHeight = 180) {
    const ref = useRef(null);
    const [size, setSize] = useState({ width: 600, height: fallbackHeight });
    useEffect(() => {
        const element = ref.current;
        if (!element || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(([entry]) => {
            const { width, height } = entry.contentRect;
            setSize((previous) => {
                const next = { width: Math.floor(width), height: Math.floor(height) };
                return previous.width === next.width && previous.height === next.height ? previous : next;
            });
        });
        observer.observe(element);
        return () => observer.disconnect();
    }, []);
    return { ref, ...size };
}
